import { Grid } from '@mui/material';
import { useFunctionariesSwitchboardFilters } from './hook';
import FieldText from '../../../../components/general/fields/fieldText';
import { FunctionariesSwitchboardFiltersProps } from './props';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import { Checkbox } from '../../../../components/general/fields/checkbox';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { formatParams } from '../../../../../shared/utils/params';

export const FuncionariesSwitchboardFiltes = ({
    onFilter,
    loading,
}: FunctionariesSwitchboardFiltersProps) => {
    const { formik, areaOptions, positionOptions, cityOptions } =
        useFunctionariesSwitchboardFilters(onFilter);
    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre Funcionario"
                    name="nameFunctionary"
                    size="small"
                    touched={formik.touched.nameFunctionary}
                    errors={formik.errors.nameFunctionary}
                    value={formik.values.nameFunctionary}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Correo electrónico"
                    name="emailFunctionary"
                    size="small"
                    touched={formik.touched.emailFunctionary}
                    errors={formik.errors.emailFunctionary}
                    value={formik.values.emailFunctionary}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(areaOptions)}
                    label="Área Funcionario"
                    name="areaFunctionary"
                    size="small"
                    disabled={false}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.areaFunctionary}
                    errors={formik.errors.areaFunctionary}
                    value={formik.values.areaFunctionary}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('areaFunctionary', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(cityOptions)}
                    label="Ciudad"
                    name="cityId"
                    size="small"
                    disabled={false}
                    onBlur={formik.handleBlur}
                    touched={(formik.touched as any).cityId}
                    errors={(formik.errors as any).cityId}
                    value={(formik.values as any).cityId}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('cityId', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(positionOptions)}
                    label="Cargo Funcionario"
                    name="positionFunctionary"
                    size="small"
                    disabled={false}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.positionFunctionary}
                    errors={formik.errors.positionFunctionary}
                    value={formik.values.positionFunctionary}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('positionFunctionary', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={1}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
